import React, { useState } from "react";
import Home from "./home/Home";
import "./App.css";
import { Switch, Route } from "react-router-dom";
import Projects from "./projects/Projects";
import Contact from "./contact/Contact";
import { AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";
import logo from "./images/axellogo.png";
import About from "./About";

function App() {
  const [loading, setLoading] = useState(true);
  setTimeout(() => {
    setLoading(false);
  }, [1500]);

  const location = useLocation();

  if (loading) {
    return (
      <div className="loading">
        <img src={logo} />
      </div>
    );
  }

  return (
    <div>
      <AnimatePresence exitBeforeEnter>
        <Switch location={location} key={location.pathname}>
          <Route path="/" exact component={Home} />
          <Route path="/projects" exact component={Projects} />
          <Route path="/contact" exact component={Contact} />
          <Route path="/about" exact component={About} />
        </Switch>
      </AnimatePresence>
    </div>
  );
}

export default App;
